import React from 'react'
import GAQuickTaleDetailsContainer from '../../modules/GAQuickTales/containers/GAQuickTaleDetailsContainer/GAQuickTaleDetailsContainer'

const GAQuickTaleDetails = () => {
  return (
    <GAQuickTaleDetailsContainer />
  )
}

export default GAQuickTaleDetails